import { render, staticRenderFns } from "./KamiCertificate.vue?vue&type=template&id=36c17b26&scoped=true&"
import script from "./KamiCertificate.vue?vue&type=script&lang=js&"
export * from "./KamiCertificate.vue?vue&type=script&lang=js&"
import style0 from "./KamiCertificate.vue?vue&type=style&index=0&id=36c17b26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c17b26",
  null
  
)

export default component.exports